import { Component, Input } from '@angular/core';

import { IFooterButton } from './buttons-footer.model';

@Component({
  selector: 'app-opin-buttons-footer',
  templateUrl: './buttons-footer.component.html',
  styleUrls: ['./buttons-footer.component.scss'],
  standalone: false
})
export class OpinButtonsFooterComponent {
  @Input() buttons: [IFooterButton, IFooterButton];
}
